import { useBackend } from "../../services";

export const useModifyOriginCountry = () => {
  const { put } = useBackend();
  const modifyOriginCountry = (parameters: IModifyOriginCountryParameters) =>
    put("originCountries", parameters);
  return { modifyOriginCountry };
};

export interface IModifyOriginCountryParameters {
  uuid: string;
  name: string;
  countryIsoCode?: string;
}
